import Axios from 'axios'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.LC + (config.isProd ? '/b2/ali-personal-service/g2e/api/staffOT/' : '/b2/personal-service/g2e/api/staffOT/')

Axios.defaults.headers.timeout = 8000

export default {

  getStaffOTProposalInfo (searchMonth, searchYear, cb) {
    Axios.get(baseUrl + 'getStaffOTProposalInfo?searchMonth=' + searchMonth + '&searchYear=' + searchYear)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  getStaffOTInfo (searchMonth, searchYear, cb) {
    Axios.get(baseUrl + 'getStaffOTInfo?searchMonth=' + searchMonth + '&searchYear=' + searchYear)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  },

  getStaffOTDafConfirmedInfo (searchMonth, searchYear, cb) {
    let monthQuery = ''
    if (searchMonth) {
      monthQuery = 'searchMonth=' + searchMonth + '&'
    }
    Axios.get(baseUrl + 'getStaffOTDafConfirmedInfo?' + monthQuery + 'searchYear=' + searchYear)
      .then(
        response => {
          cb(response)
        }
      )
      .catch(error => {
        console.log(error)
        cb(error.response)
      })
  }

}
